import { post } from '@elementary/common-ui/utils/http';
import {
  TableAssetsFiltersQueryResponse,
  TableAssetsQueryRequest,
  TableAssetsQueryResponse,
} from 'catalog/components/CoverageTable/types';
import { ArrayChanges } from 'shared/types';

export type EditResourcesApi = {
  data: {
    edit_resources: Array<{
      resource_name: string;
      source_name?: string;
      asset_id: string;
      tags?: ArrayChanges | null;
      owners?: ArrayChanges | null;
      description?: string;
    }>;
  };
};

export type CoverageStatsResponse = {
  totalAssets: number;
  totalCriticalAssets: number;
  avgCoverage: number;
  avgCriticalCoverage: number;
  dimensionPercentages: Record<string, number>;
};

export const editResources = (
  args: EditResourcesApi,
  envId: string,
  ticketId?: string,
): Promise<void> =>
  post(
    `${
      import.meta.env.VITE_API_BASE_URL
    }/environments/${envId}/pull-requests/edit_resources`,
    {
      ...args,
      ...(ticketId ? { ticket_id: ticketId } : {}),
    },
  );

export const generateAssetsDescription = (
  args: { asset_ids: string[] },
  envId: string,
): Promise<Record<string, string>> =>
  post(
    `${import.meta.env.VITE_API_BASE_URL}/${envId}/assets/generate-description`,
    args,
  );

export const fetchCoverageStats = (
  envId: string,
  filters: TableAssetsQueryRequest['filters'],
  daysBack: number,
): Promise<CoverageStatsResponse> => {
  const url = `${
    import.meta.env.VITE_API_BASE_URL
  }/${envId}/assets/coverage/stats?days_back=${daysBack}`;
  return post(url, filters);
};

export const tableAssetsCoverageQuery = (
  args: TableAssetsQueryRequest,
  envId: string,
  daysBack: number,
): Promise<TableAssetsQueryResponse> => {
  const url = `${
    import.meta.env.VITE_API_BASE_URL
  }/${envId}/assets/coverage?days_back=${daysBack}`;
  return post(url, args);
};

export const tableAssetsCoverageFilterOptionsQuery = (
  args: TableAssetsQueryRequest,
  envId: string,
  daysBack: number,
): Promise<TableAssetsFiltersQueryResponse> => {
  const url = `${
    import.meta.env.VITE_API_BASE_URL
  }/${envId}/assets/coverage/filter-options?days_back=${daysBack}`;
  return post(url, args);
};
